import { render, staticRenderFns } from "./TimeRenderer.vue?vue&type=template&id=4c0cd3e5"
import script from "./TimeRenderer.vue?vue&type=script&lang=js"
export * from "./TimeRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports